export default {
  aggregates: {
    aggregated: 'Aggregated results',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'ago',
    from: 'from',
    since: 'since',
    unit: {
      DAY: 'day|days',
      MONTH: 'month|months',
      YEAR: 'year|years'
    },
    untilNow: 'until now'
  },
  categoryDetails: {
    average: 'The average value is {average}. {benchmark}',
    chartLabel: {
      noLabel: 'No',
      yesLabel: 'Yes'
    },
    condensedQuestionTitlePrefix: 'Follow-up questions for',
    description:
      "This shows how the team's responses to all questions in the category are distributed.",
    hideOwnAnswers: 'Hide own answers',
    noResponses: 'No responses',
    notParticipating: 'You have not responded to these questions yourself.',
    numberOfPeople: 'Respondees',
    sensitiveQuestion: 'Only visible for you as a manager.',
    showFollowUpQuestions: 'Show follow-up questions',
    showFollowUpQuestionsCondensed: 'Condensed view',
    toggleButton: {
      overview: 'Overview',
      questions: 'Questions'
    },
    tooltip: {
      barValue: 'no one | 1 person | {count} people',
      barValueAnswers: 'no one | 1 answer | {count} answers',
      barValueCondensed: 'answered {label}',
      noHistoryForQuestion:
        'This question has not been asked previously in the selected time period.',
      nooneFollowupQuestionsRelevant:
        'No relevant follow-up question responses to show',
      nooneFollowupQuestionsSameLabel:
        'No one has responded {yesLabel} to a follow-up question',
      nooneOtherQuestionsCondensed:
        'No one has responsed {yesLabel} to the other follow-up questions'
    },
    workWith: 'How to work with {categoryName}',
    yourResponse: 'You responded:'
  },
  error: {
    couldNotLoadAggregates: 'Could not load aggregated results.',
    couldNotLoadResults: 'Could not load results.',
    networkError:
      'There was a problem loading data from Internet. Do you have a working connection?',
    unknown: 'There is an unknown error'
  },
  errors: {
    status: {
      BadRequest: 'Bad request to server',
      Forbidden: 'It is not allowed to access this resource',
      InternalServerError:
        'Something went wrong on the server, please contact support if this persists',
      NotFound: 'Could not find what you are looking for',
      Unauthorized: 'You are not authorized to access this resource',
      UnknownError: 'Unknown error occurred'
    }
  },
  freetext: {
    loadResponses: 'Load responses',
    noFreeTextQuestions:
      'When you have free text questions in your survey, you will be able to see all responses here.',
    notEnoughResponses: 'Not enough responses.',
    responses: 'No responses|{count} response | {count} responses'
  },
  general: {
    add: 'Add',
    cancel: 'Cancel',
    entireOrganization: 'Entire organization',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} is the average value for questions within {title}. {compareToBenchmark}',
    currentValue: 'Current value',
    filter: {
      findGroups: 'Find groups',
      shouldExportWithHierarchy: 'Include underlying groups'
    },
    loadMore: 'Load more',
    loadMoreInGroup: 'Load more under {groupName}',
    noone: 'No one has responded',
    noResults:
      'Not enough responses for this group yet. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'have responded',
    nps: 'Net Promoter Score',
    nps_detractors: 'Detractors',
    nps_passives: 'Passives',
    nps_promoters: 'Promoters',
    questions: 'Questions in category',
    showTrend: 'Show change',
    selectTableGroups: 'Select groups to show',
    groupSelectorDescription:
      'Decide which groups to show in the comparison view.',
    selectAll: 'All',
    enableTrend: 'Show trend',
    showSensitive: 'Show sensitive',
    violationsIn:
      'Reports have been made that violations have occured within {groupName}. Please contact the HR department who can tell you more and help you work the issue moving forward.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Select a date as starting point for the history.',
      selectDate: 'Would show history for surveys since {date}.',
      selectedDate: 'Showing history for surveys since {date}.'
    },
    selectorOptions: {
      custom: 'custom',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Try again'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Current surveys',
    help: 'Help',
    myActivities: 'Actions',
    ourResults: 'Results',
    overview: 'Overview',
    team: 'Team',
    welcome: 'Welcome'
  },
  page: {
    results: 'All Results'
  },
  resultDetails: {
    backToResults: 'Go back',
    exportData: 'Export',
    exportModal: {
      includeSensitiveQuestions: 'Include sensitive questions',
      loadingMessage:
        'Preparing data for export, this will take a little while.',
      saveAsExcelAllGroupsDescription:
        'By exporting to Excel you will get a file with results for {groupTitle} and all underlying groups.. This is good if you want to do your own multi-group analysis or calculations.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'By exporting to Excel you will get a file with results for {groupTitle}{segmentInfo}. This is good if you want to do your own analysis or calculations.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'You will get a PDF-document with results for all categories and questions for the selected group. Useful when you want to print the results.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'A PowerPoint export will get you a nice presentation with results for {groupTitle}{segmentInfo}. Perfect when you need to show results to others on a big screen.'
    },
    notes: {
      draggable: {
        explanation: 'Only visible to you',
        placeholder:
          'Write your own notes, comments and reflections about the survey here',
        title: 'Personal notes'
      },
      status: {
        initial: 'Saving automatically as you type',
        saved: 'Changes saved!',
        unsaved: 'Saving soon...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'There are not enough responses to display results per user'
        },
        description: {
          high: 'One person that responded so their average score became green.|There are {count} people that responded so their average score became green.',
          low: 'One person that responded so their average score became red.|There are {count} people that responded so their average score became red.',
          medium:
            'There is one person that responded so their average score became yellow.|There are {count} people that responded so their average score became yellow.'
        },
        title: 'Noone|One person|{count} people'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Your score is the same as the Pulsᐩ benchmark® for {title}.',
        higherThanBenchmarkValue:
          'Your score is {benchmarkDiff} higher than the Pulsᐩ benchmark® for {title} which is {benchmarkValue}. Nice!',
        lowerThanBenchmarkValue:
          'You are {benchmarkDiff} lower than the Pulsᐩ benchmark® for {title} which is {benchmarkValue}',
        percentagePoints: 'percentage points'
      },
      enps: {
        button: {
          description:
            'You will be sent to our partner, EQI, that collects benchmarking data for a large number of organizations and provides more detailed insight regarding your own eNPS-score.',
          title: 'Compare your eNPS score with other organizations'
        }
      },
      toggleButton: {
        history: 'History',
        overview: 'Overview'
      }
    }
  },
  results: {
    aggregated: 'Aggregated',
    chooseSurvey: 'Choose survey',
    finished: 'Completed',
    published: 'Ongoing',
    noSurveys: 'No results available',
    reloadSurveys: 'Reload'
  },
  resultsmessages: {
    historyTitle: 'Conversation history',
    newMessage: 'New conversation',
    clearHistory: 'Clear history',
    disclaimer: 'Pulsᐩ AI uses generative AI and can make mistakes.',
    error: {
      generic:
        'Uh, oh... something is not working as expected. Please try to reload the page.',
      notEnoughResults:
        'No result to talk about. Please select a different group or survey to use Pulsᐩ AI.'
    },
    moreInfo: 'Learn how to use Pulsᐩ AI as a leader',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Ask a question about results...',
    reload: 'Reload page',
    report: 'Report problem',
    send: 'Send',
    suggestionHeader: 'Here are some suggestions for questions you can ask:',
    suggestions: {
      groupsComparison: {
        1: 'Which groups should I focus on?',
        2: 'Is there a question that most groups should work on?',
        3: 'Which groups show negative trends?',
        4: 'Which groups show positive trends?',
        5: 'Which groups stand out negatively?',
        6: 'Which groups need my attention?',
        7: 'What should I do first?'
      },
      overview: {
        1: 'What should I do with our results?',
        2: 'How can I present this to my team?',
        3: 'Overall, what does the results tell us?',
        4: 'Which top 3 actions should I focus on?',
        5: 'What in my leadership can I improve?',
        6: 'Which risks should I be aware of?',
        7: 'What can happen if we do not act?',
        8: 'What should I prioritize?',
        9: 'How does the forecast look for {groupName}?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Everyone'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Compare'
        },
        export: {
          title: 'Export'
        },
        freetext: {
          title: 'Free text'
        },
        results: {
          title: 'Survey results'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Not possible to show statistics without risking losing anonymity.',
    others: 'Other | Others',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administration',
    currentSurveys: 'Current surveys',
    dashboard: 'Dashboard',
    help: 'Help',
    logOut: 'Log out',
    myActivities: 'My actions',
    ourResults: 'Our results'
  },
  topbanner: {
    preview: {
      body: 'You are now looking at the new version of Pulsᐩ results view which has many improvements. We hope you like it!',
      header: 'New version!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'During the time period {startDate} - {endDate} the result has decreased for {categoryName}.',
        trend_increased:
          'During the time period {startDate} - {endDate} the result has increased for {categoryName}. Keep up the good work!',
        trend_same:
          'The result has remained the same for {categoryName} during the time period {startDate} - {endDate}.'
      }
    },
    noTrend: "There's no older survey to compare with.",
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Compared to previous survey at {oldSurveyDate} the result has decreased by {changeInPercent}% for {tagName}.',
        nps_trend_increased:
          'Compared to previous survey at {oldSurveyDate} the result has increased by {changeInPercent}% for {tagName}.',
        nps_trend_same:
          'The result has remained about the same ({changeInPercent}% change) for {tagName} since last survey at {oldSurveyDate}.',
        trend_decreased:
          'During the time period {startDate} - {endDate} the result has decreased for {tagName}.',
        trend_increased:
          'During the time period {startDate} - {endDate} the result has increased for {tagName}',
        trend_same:
          'The result has remained the same for {categoryName} during the time period {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'All groups',
    cannotChangeGroupsWhileComparing:
      "While in the comparison view you're looking at multiple groups at the same time.",
    group: 'Group',
    segment: 'Segment',
    survey: 'Survey'
  },
  widgetResultsMessages: {
    historyTitle: 'Overall results',
    waiting: 'Waiting for Pulsᐩ AI...',
    loading: 'Loading your personal insights...',
    error: {
      generic: 'Could not load Pulsᐩ AI. Please try again later.'
    },
    retry: 'Retry'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Number of people that selected at least an action',
      totalActions: 'Total number of actions selected'
    },
    title: 'Actions summary'
  },
  widgetAlert: {
    actions: {
      saved: 'Thanks, the activity was saved.'
    },
    links: {
      tooltip: 'Link opens in a new window'
    },
    notEnoughData: 'There is nothing to display here right now.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Most recently reported {surveyDate}.'
      },
      question: {
        resultsFromManyAggregates: 'Contains results from these surveys:',
        info: 'Most recently asked {surveyDate} in "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'There are not yet enough responses to display anything here.',
    title: 'Categories',
    toggles: {
      currentSurveysOnly: {
        description: 'Only show results for {surveyName}',
        title: 'This survey',
        valueDescription: 'Showing results for {surveyName}'
      }
    },
    tooltip: {
      value:
        'This is the average value for all responses to questions within {categoryName} answered by people in {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      "An unexpected error occured when the widget was trying to load. First try to reload the page. If the problem persists, please report the problem to us and we'll take a look at it right away!",
    hideErrorDetails: 'Hide error details',
    showErrorDetails: 'Show error details',
    title: 'Problem in widget!'
  },
  widgetGroupActions: {
    allCategories: 'Within all categories',
    freeText: {
      alert: {
        noResults: 'Nothing found. Try typing something else.',
        typeMore: 'Type some more'
      },
      filterField: {
        placeholder: 'Type to find comments'
      },
      numberOfComments: '{numberOfComments} comments'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'How to develop personal responsibility among your employees'
      }
    },
    noActions: 'There are no actions to display.',
    noActionsSelectedInCategory: 'There are no actions selected',
    otherActions: 'Own actions',
    people:
      'No actions selected | {count} action selected | {count} actions selected',
    peopleSelectedActions:
      'Out of {peopleResponded} people responded only 1 has selected at least one action ({percentage}%)| Out of {peopleResponded} people responded, {count} people selected at least one action ({percentage}%)',
    title: 'Chosen actions for people in {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 person selected this action| {count} people selected this action'
    }
  },
  widgetGroupPriorities: {
    description:
      'These are the most important areas to focus on right now, according to the survey participants.',
    freeTextResponses: 'Show free text responses',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'How to develop your team with Pulsᐩ'
      }
    },
    noPriorities: 'There are no priorities chosen by the participants.',
    people: 'no one | {count} person | {count} people',
    thinkImportant: ' think "{category}" is most important',
    title: 'Priorities for people in {groupName}'
  },
  widgetNotImplemented: {
    content: 'Not implemented yet'
  },
  widgetSurveyInfo: {
    endDate: 'End date',
    noone: 'No one has responded',
    notEnoughResponses: {
      aggregate:
        'Not enough people responded in the time period in order to show results.',
      completed:
        'Not enough people responded to the survey in order to show results.',
      published:
        'Not yet enough people that have responded to the survey in order to show results.'
    },
    participation: {
      title: 'Participation'
    },
    startDate: 'Start date',
    status: {
      completed: 'Survey is completed! These are the final results.',
      published: 'Survey is still ongoing. The results are preliminary.'
    },
    usersInvited: 'People invited',
    usersResponded: 'People responded'
  },
  widgetTagsDonuts: {
    description: {
      all: 'These are latest results for {groupName}.'
    },
    notEnoughResponses:
      'There are not yet enough responses to display anything here.',
    title: {
      company: 'All of {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS stands for Employee Net Promoter Score and measures how willing employees are to advocate employment at their company.',
      nps_description:
        'NPS stands for Net Promoter Score and is a measurement of how likely people are to recommend something to others.',
      nps_detractors: 'Detractors',
      nps_passives: 'Passives',
      nps_promoters: 'Promoters',
      value:
        'This is the average value for all responses to questions in {tagName} answered by people in {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} over time',
    twoTags: '{tag1} and {tag2}'
  }
}
